import CreatePin from './CreatePin.jsx'

export default CreatePin;